/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedApplicationsRouteRouteImport } from './routes/_authenticated/applications/route'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedLoanMonitoringRouteImport } from './routes/_authenticated/loan-monitoring'
import { Route as AuthenticatedApplicationsIndexRouteImport } from './routes/_authenticated/applications/index'
import { Route as AuthenticatedApplicationsDetailRouteImport } from './routes/_authenticated/applications/$detail'
import { Route as AuthenticatedCustomersIndexRouteImport } from './routes/_authenticated/customers/index'
import { Route as AuthenticatedCustomersCustomerIdRouteImport } from './routes/_authenticated/customers/$customerId'
import { Route as AuthenticatedPdlScoreIdRouteImport } from './routes/_authenticated/pdl/$scoreId'
import { Route as AuthenticatedPdlMonitoringRouteImport } from './routes/_authenticated/pdl/monitoring'
import { Route as AuthenticatedPdlApplicationsIndexRouteImport } from './routes/_authenticated/pdl/applications/index'
import { Route as AuthenticatedPdlApplicationsApplicationIdRouteImport } from './routes/_authenticated/pdl/applications/$applicationId'
import { Route as AuthenticatedPdlLoansIndexRouteImport } from './routes/_authenticated/pdl/loans/index'
import { Route as AuthenticatedPdlLoansLoanIdRouteImport } from './routes/_authenticated/pdl/loans/$loanId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedApplicationsRouteRoute =
  AuthenticatedApplicationsRouteRouteImport.update({
    id: '/applications',
    path: '/applications',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedLoanMonitoringRoute =
  AuthenticatedLoanMonitoringRouteImport.update({
    id: '/loan-monitoring',
    path: '/loan-monitoring',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedApplicationsIndexRoute =
  AuthenticatedApplicationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedApplicationsRouteRoute,
  } as any)
const AuthenticatedApplicationsDetailRoute =
  AuthenticatedApplicationsDetailRouteImport.update({
    id: '/$detail',
    path: '/$detail',
    getParentRoute: () => AuthenticatedApplicationsRouteRoute,
  } as any)
const AuthenticatedCustomersIndexRoute =
  AuthenticatedCustomersIndexRouteImport.update({
    id: '/customers/',
    path: '/customers/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCustomersCustomerIdRoute =
  AuthenticatedCustomersCustomerIdRouteImport.update({
    id: '/customers/$customerId',
    path: '/customers/$customerId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPdlScoreIdRoute = AuthenticatedPdlScoreIdRouteImport.update({
  id: '/pdl/$scoreId',
  path: '/pdl/$scoreId',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPdlMonitoringRoute =
  AuthenticatedPdlMonitoringRouteImport.update({
    id: '/pdl/monitoring',
    path: '/pdl/monitoring',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPdlApplicationsIndexRoute =
  AuthenticatedPdlApplicationsIndexRouteImport.update({
    id: '/pdl/applications/',
    path: '/pdl/applications/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPdlApplicationsApplicationIdRoute =
  AuthenticatedPdlApplicationsApplicationIdRouteImport.update({
    id: '/pdl/applications/$applicationId',
    path: '/pdl/applications/$applicationId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPdlLoansIndexRoute =
  AuthenticatedPdlLoansIndexRouteImport.update({
    id: '/pdl/loans/',
    path: '/pdl/loans/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPdlLoansLoanIdRoute =
  AuthenticatedPdlLoansLoanIdRouteImport.update({
    id: '/pdl/loans/$loanId',
    path: '/pdl/loans/$loanId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/applications': typeof AuthenticatedApplicationsRouteRouteWithChildren
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/loan-monitoring': typeof AuthenticatedLoanMonitoringRoute
  '/applications/$detail': typeof AuthenticatedApplicationsDetailRoute
  '/customers/$customerId': typeof AuthenticatedCustomersCustomerIdRoute
  '/pdl/$scoreId': typeof AuthenticatedPdlScoreIdRoute
  '/pdl/monitoring': typeof AuthenticatedPdlMonitoringRoute
  '/applications/': typeof AuthenticatedApplicationsIndexRoute
  '/customers/': typeof AuthenticatedCustomersIndexRoute
  '/pdl/applications/$applicationId': typeof AuthenticatedPdlApplicationsApplicationIdRoute
  '/pdl/loans/$loanId': typeof AuthenticatedPdlLoansLoanIdRoute
  '/pdl/applications/': typeof AuthenticatedPdlApplicationsIndexRoute
  '/pdl/loans/': typeof AuthenticatedPdlLoansIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/loan-monitoring': typeof AuthenticatedLoanMonitoringRoute
  '/applications/$detail': typeof AuthenticatedApplicationsDetailRoute
  '/customers/$customerId': typeof AuthenticatedCustomersCustomerIdRoute
  '/pdl/$scoreId': typeof AuthenticatedPdlScoreIdRoute
  '/pdl/monitoring': typeof AuthenticatedPdlMonitoringRoute
  '/applications': typeof AuthenticatedApplicationsIndexRoute
  '/customers': typeof AuthenticatedCustomersIndexRoute
  '/pdl/applications/$applicationId': typeof AuthenticatedPdlApplicationsApplicationIdRoute
  '/pdl/loans/$loanId': typeof AuthenticatedPdlLoansLoanIdRoute
  '/pdl/applications': typeof AuthenticatedPdlApplicationsIndexRoute
  '/pdl/loans': typeof AuthenticatedPdlLoansIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_authenticated/applications': typeof AuthenticatedApplicationsRouteRouteWithChildren
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/loan-monitoring': typeof AuthenticatedLoanMonitoringRoute
  '/_authenticated/applications/$detail': typeof AuthenticatedApplicationsDetailRoute
  '/_authenticated/customers/$customerId': typeof AuthenticatedCustomersCustomerIdRoute
  '/_authenticated/pdl/$scoreId': typeof AuthenticatedPdlScoreIdRoute
  '/_authenticated/pdl/monitoring': typeof AuthenticatedPdlMonitoringRoute
  '/_authenticated/applications/': typeof AuthenticatedApplicationsIndexRoute
  '/_authenticated/customers/': typeof AuthenticatedCustomersIndexRoute
  '/_authenticated/pdl/applications/$applicationId': typeof AuthenticatedPdlApplicationsApplicationIdRoute
  '/_authenticated/pdl/loans/$loanId': typeof AuthenticatedPdlLoansLoanIdRoute
  '/_authenticated/pdl/applications/': typeof AuthenticatedPdlApplicationsIndexRoute
  '/_authenticated/pdl/loans/': typeof AuthenticatedPdlLoansIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/applications'
    | '/dashboard'
    | '/loan-monitoring'
    | '/applications/$detail'
    | '/customers/$customerId'
    | '/pdl/$scoreId'
    | '/pdl/monitoring'
    | '/applications/'
    | '/customers/'
    | '/pdl/applications/$applicationId'
    | '/pdl/loans/$loanId'
    | '/pdl/applications/'
    | '/pdl/loans/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/loan-monitoring'
    | '/applications/$detail'
    | '/customers/$customerId'
    | '/pdl/$scoreId'
    | '/pdl/monitoring'
    | '/applications'
    | '/customers'
    | '/pdl/applications/$applicationId'
    | '/pdl/loans/$loanId'
    | '/pdl/applications'
    | '/pdl/loans'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_authenticated/applications'
    | '/_authenticated/dashboard'
    | '/_authenticated/loan-monitoring'
    | '/_authenticated/applications/$detail'
    | '/_authenticated/customers/$customerId'
    | '/_authenticated/pdl/$scoreId'
    | '/_authenticated/pdl/monitoring'
    | '/_authenticated/applications/'
    | '/_authenticated/customers/'
    | '/_authenticated/pdl/applications/$applicationId'
    | '/_authenticated/pdl/loans/$loanId'
    | '/_authenticated/pdl/applications/'
    | '/_authenticated/pdl/loans/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/applications': {
      id: '/_authenticated/applications'
      path: '/applications'
      fullPath: '/applications'
      preLoaderRoute: typeof AuthenticatedApplicationsRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/loan-monitoring': {
      id: '/_authenticated/loan-monitoring'
      path: '/loan-monitoring'
      fullPath: '/loan-monitoring'
      preLoaderRoute: typeof AuthenticatedLoanMonitoringRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/applications/': {
      id: '/_authenticated/applications/'
      path: '/'
      fullPath: '/applications/'
      preLoaderRoute: typeof AuthenticatedApplicationsIndexRouteImport
      parentRoute: typeof AuthenticatedApplicationsRouteRoute
    }
    '/_authenticated/applications/$detail': {
      id: '/_authenticated/applications/$detail'
      path: '/$detail'
      fullPath: '/applications/$detail'
      preLoaderRoute: typeof AuthenticatedApplicationsDetailRouteImport
      parentRoute: typeof AuthenticatedApplicationsRouteRoute
    }
    '/_authenticated/customers/': {
      id: '/_authenticated/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof AuthenticatedCustomersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/customers/$customerId': {
      id: '/_authenticated/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/customers/$customerId'
      preLoaderRoute: typeof AuthenticatedCustomersCustomerIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pdl/$scoreId': {
      id: '/_authenticated/pdl/$scoreId'
      path: '/pdl/$scoreId'
      fullPath: '/pdl/$scoreId'
      preLoaderRoute: typeof AuthenticatedPdlScoreIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pdl/monitoring': {
      id: '/_authenticated/pdl/monitoring'
      path: '/pdl/monitoring'
      fullPath: '/pdl/monitoring'
      preLoaderRoute: typeof AuthenticatedPdlMonitoringRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pdl/applications/': {
      id: '/_authenticated/pdl/applications/'
      path: '/pdl/applications'
      fullPath: '/pdl/applications/'
      preLoaderRoute: typeof AuthenticatedPdlApplicationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pdl/applications/$applicationId': {
      id: '/_authenticated/pdl/applications/$applicationId'
      path: '/pdl/applications/$applicationId'
      fullPath: '/pdl/applications/$applicationId'
      preLoaderRoute: typeof AuthenticatedPdlApplicationsApplicationIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pdl/loans/': {
      id: '/_authenticated/pdl/loans/'
      path: '/pdl/loans'
      fullPath: '/pdl/loans/'
      preLoaderRoute: typeof AuthenticatedPdlLoansIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pdl/loans/$loanId': {
      id: '/_authenticated/pdl/loans/$loanId'
      path: '/pdl/loans/$loanId'
      fullPath: '/pdl/loans/$loanId'
      preLoaderRoute: typeof AuthenticatedPdlLoansLoanIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedApplicationsRouteRouteChildren {
  AuthenticatedApplicationsDetailRoute: typeof AuthenticatedApplicationsDetailRoute
  AuthenticatedApplicationsIndexRoute: typeof AuthenticatedApplicationsIndexRoute
}

const AuthenticatedApplicationsRouteRouteChildren: AuthenticatedApplicationsRouteRouteChildren =
  {
    AuthenticatedApplicationsDetailRoute: AuthenticatedApplicationsDetailRoute,
    AuthenticatedApplicationsIndexRoute: AuthenticatedApplicationsIndexRoute,
  }

const AuthenticatedApplicationsRouteRouteWithChildren =
  AuthenticatedApplicationsRouteRoute._addFileChildren(
    AuthenticatedApplicationsRouteRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedApplicationsRouteRoute: typeof AuthenticatedApplicationsRouteRouteWithChildren
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedLoanMonitoringRoute: typeof AuthenticatedLoanMonitoringRoute
  AuthenticatedCustomersCustomerIdRoute: typeof AuthenticatedCustomersCustomerIdRoute
  AuthenticatedPdlScoreIdRoute: typeof AuthenticatedPdlScoreIdRoute
  AuthenticatedPdlMonitoringRoute: typeof AuthenticatedPdlMonitoringRoute
  AuthenticatedCustomersIndexRoute: typeof AuthenticatedCustomersIndexRoute
  AuthenticatedPdlApplicationsApplicationIdRoute: typeof AuthenticatedPdlApplicationsApplicationIdRoute
  AuthenticatedPdlLoansLoanIdRoute: typeof AuthenticatedPdlLoansLoanIdRoute
  AuthenticatedPdlApplicationsIndexRoute: typeof AuthenticatedPdlApplicationsIndexRoute
  AuthenticatedPdlLoansIndexRoute: typeof AuthenticatedPdlLoansIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedApplicationsRouteRoute:
    AuthenticatedApplicationsRouteRouteWithChildren,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedLoanMonitoringRoute: AuthenticatedLoanMonitoringRoute,
  AuthenticatedCustomersCustomerIdRoute: AuthenticatedCustomersCustomerIdRoute,
  AuthenticatedPdlScoreIdRoute: AuthenticatedPdlScoreIdRoute,
  AuthenticatedPdlMonitoringRoute: AuthenticatedPdlMonitoringRoute,
  AuthenticatedCustomersIndexRoute: AuthenticatedCustomersIndexRoute,
  AuthenticatedPdlApplicationsApplicationIdRoute:
    AuthenticatedPdlApplicationsApplicationIdRoute,
  AuthenticatedPdlLoansLoanIdRoute: AuthenticatedPdlLoansLoanIdRoute,
  AuthenticatedPdlApplicationsIndexRoute:
    AuthenticatedPdlApplicationsIndexRoute,
  AuthenticatedPdlLoansIndexRoute: AuthenticatedPdlLoansIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
